module.exports = __webpack_public_path__ + "img/tuijianchapin.8ab4a218.png";